import { c as _c } from "react/compiler-runtime";
import type { ThemeProviderProps } from "next-themes";
import { ThemeProvider as NextThemeProvider } from "next-themes";
export const ThemeProvider = t0 => {
  const $ = _c(6);
  let children;
  let properties;
  if ($[0] !== t0) {
    ({
      children,
      ...properties
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = properties;
  } else {
    children = $[1];
    properties = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== properties) {
    t1 = <NextThemeProvider attribute="class" defaultTheme="system" disableTransitionOnChange={true} enableSystem={true} {...properties}>{children}</NextThemeProvider>;
    $[3] = children;
    $[4] = properties;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};